import { Col, Form, Row, Switch } from "antd"
import { useEffect, useState } from "react";
import AddressSection from "./Components/AddressSection";
import { useParams } from "react-router-dom";
import dayjs from 'dayjs'
import { useGlobal } from "../../System/Global/GlobalProvider";
import { parseStringifiedArrays, unescapeNested } from "../../System/Global/unescapeArray";
import { FileViewer } from "./Components/FileViewer";
import { getRecords } from "../../System/Api/OPEXAPI";

export const BookingView = () => {

    const [ form ] = Form.useForm()
    const { UserData } = useGlobal()
    const [ client, setClient ] = useState()
    const [ collections, setCollections ] = useState([])
    const [ deliveries, setDeliveries ] = useState([])
    const { bookingKey } = useParams();
    const [isRoundTrip, setIsRoundTrip] = useState(false); 
    const [ booking, setBooking ] = useState();
    const [ isLoading, setIsLoading ] = useState(false)


    const generateAddress = (b, prefix) => {

        
        let newAddresses = [{
            name:           b[`${prefix}_name`],
            addressLine1:   b[`${prefix}_addressLine1`],
            addressLine2:   b[`${prefix}_addressLine2`],
            addressLine3:   b[`${prefix}_addressLine3`],
            townName:       b[`${prefix}_townName`],
            postCode:       b[`${prefix}_postCode`],
            country:        b[`${prefix}_country`],
            date:           dayjs(b[`${prefix}_date`]).format('YYYY-MM-DD'),
            time:           b[`${prefix}_time`],
            timeType:       b[`${prefix}_time`] !== "ASAP" ? "Timed" : "ASAP",
            instructions:   b[`${prefix}_instructions`],
            reference:      b[`${prefix}_reference`],
        }]

        
        let items = prefix === "col" ? b.collections : b.deliveries;

        if (Array.isArray(items)) {
            items.forEach(item => newAddresses.push({
                name:           item[`${prefix}_name`],
                addressLine1:   item[`${prefix}_addressLine1`],
                addressLine2:   item[`${prefix}_addressLine2`],
                addressLine3:   item[`${prefix}_addressLine3`],
                townName:       item[`${prefix}_townName`],
                postCode:       item[`${prefix}_postCode`],
                country:        item[`${prefix}_country`],
                date:           dayjs(item[`${prefix}_date`]).format('YYYY-MM-DD'),
                time:           item[`${prefix}_time`],
                timeType:       item[`${prefix}_time`] !== "ASAP" ? "Timed" : "ASAP",
                instructions:   item[`${prefix}_instructions`],
                reference:      item[`${prefix}_reference`],
            }))
        } else {
            console.error('items is not an array:', items)
        }

        if (prefix === "col") {
            setCollections(newAddresses)
        } else {
            setDeliveries(newAddresses)
        }

    }

    useEffect( () => {

        ( async () => {

            
            let query = "SELECT * FROM bookings WHERE bookingKey = ?"
            let bindings = [bookingKey]
            let _booking = await getRecords(query, bindings)
            _booking = unescapeNested(_booking[0])
            _booking = parseStringifiedArrays(_booking)

            
            let _bookingDraft = await getRecords(`SELECT * FROM bookings_draft WHERE bookingKeyNew = ?`, bindings)

            
            if (_bookingDraft.length > 0) {
                _bookingDraft = unescapeNested(_bookingDraft[0])
                _bookingDraft = parseStringifiedArrays(_bookingDraft)
            }

            

            let user = await getRecords(`SELECT * FROM users WHERE userKey = ?`, [ _booking.userKey ])
            user = unescapeNested(user[0])
            user = parseStringifiedArrays(user)
            _booking.user = user

            let userDraft = await getRecords(`SELECT * FROM users WHERE userKey = ?`, [ _bookingDraft.userKey ])
            userDraft = unescapeNested(userDraft[0])
            userDraft = parseStringifiedArrays(userDraft)
            _booking.userDraft = userDraft
            
            setBooking(_booking)

            generateAddress(_booking, 'col')
            generateAddress(_booking, 'del')

                
            form.setFieldsValue({
                itemCount:      _booking.itemCount,
                itemKgs:        _booking.itemKgs,
                itemText:       _booking.itemText,
                itemType:       _booking.itemType,
                typeCode:       _booking.typeCode,
                vanType:        _booking.vanType,
                basePrice:      _booking.basePrice,
                vatCode:        _booking.vatCode,
                ignorePod:      _booking.ignorePod,
                customsBooking: _booking.customsBooking,
                orderNo:        _booking.orderNo,
                customerRef:    _booking.customerRef,
            })

            

            if (_booking.roundTrip === 1) {
                setIsRoundTrip(true)
            }
            

            const _client = await getRecords(`SELECT * FROM clients WHERE clientKey = ?`, [ UserData.clientKey ])
            setClient(_client[0])
            setBooking(_booking)

            setIsLoading(false)

            
        })()
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    
    const priceCard = () => {

        return (
            
                <div style={{border: '1px solid #F1F2F5', padding: 20, margin: 10}}>

                
                
                <Row gutter={16} display="flex" align={"middle"}>
                    <Col xs={10}>
                        <Form.Item label="Price" name="basePrice" rules={[
                            {
                                required: true,
                                message: 'Please enter a price!',
                            }]}>
                                
                                <div style={{margin: 10, border: '1px solid #ddd', padding: '5px 10px'}}>£{booking.totalPrice}</div>
                                
                        </Form.Item>
                    </Col>
                    
                    
                    <Col xs={14}>
                        
                        <Form.Item label={"Vehicle Type"} name="vanType">
                                <div style={{margin: 10, border: '1px solid #ddd', padding: '5px 10px'}}>{booking.vanType}</div>
                        </Form.Item>
                    </Col>
                    
                </Row> 
                </div>
            
        )
    }
    const detailsCard = () => {

        return (
            
            

                <div style={{border: '1px solid #F1F2F5', padding: 20, margin: 10}}>
                
                <Row gutter={16} display="flex" align={"middle"}>
                    
                    <Col xs={12}>
                        <Form.Item label="Order No" name="orderNo" rules={[
                            {
                                required: true,
                                message: 'Please enter an order number!',
                            }]}>
                            <div style={{margin: 10, border: '1px solid #ddd', padding: '5px 10px'}}>{booking.orderNo}</div>
                        </Form.Item>
                        
                    </Col>
                    <Col xs={12}>
                        <Form.Item label="Your Ref (optional)" name="customerRef">
                            <div style={{margin: 10, border: '1px solid #ddd', padding: '5px 10px'}}>{booking.customerRef || <br/>}</div>
                        </Form.Item>
                    </Col>
                </Row>

                </div>
                
            
        )
    }

    

    const statusStyle = {

        padding: "5px 15px",
        backgroundColor: 'black',
        color: 'white'
    }

    return (
        isLoading ?  <Row gutter={16}>
        <Col xs={24}></Col></Row> :
        booking ?
        <div style={{padding: 20}}>
        <Row gutter={16}>
            <Col xs={24}>
            <Form form={form} layout="vertical" initialValues={booking}>
            <div style={{display: 'flex', alignItems: "center"}}>
                <div style={{flex: 1}}>
                    <h1 style={{marginTop: 0}}>View Booking {booking?.crgoRef && `#${booking.crgoRef}`}</h1>
                    { booking?.userDraft && <span>Draft created by: {booking?.userDraft?.firstName} {booking?.userDraft?.lastName}<br/></span> }
                    { booking?.user && <span>Created by: {booking?.user?.firstName} {booking?.user?.lastName}</span> }
                </div>
                <div>
                    <Switch disabled checked={isRoundTrip} style={{marginRight: 20}} checkedChildren="Round Trip" unCheckedChildren="One-way" onChange={(checked) => setIsRoundTrip(checked)} />
                </div>
                <div>
                    <div style={{
                        ...statusStyle,
                        backgroundColor: 
                            booking?.status === 'Live' ? '#e6f4ff' :
                            booking?.status === 'Transit' ? '#0958d9' :
                            booking?.status === 'Delivered' ? '#f6ffed' :
                            'black',
                        color: 
                            booking?.status === 'Live' ? '#0958d9' :
                            booking?.status === 'Transit' ? '#0958d9' :
                            booking?.status === 'Delivered' ? '#389e0d' :
                            'black',
                    }}>
                        {booking?.status}
                    </div>
                </div>
            </div>

            { booking && 

            <div>
                <>
                
                <Row gutter={10}>
                    
                    <Col span={12}>
                        <AddressSection disabled addresses={collections} setAddresses={setCollections} client={client} type="Collection"/>
                    </Col>
                    <Col span={12}>
                        <AddressSection disabled addresses={deliveries} setAddresses={setDeliveries} client={client} type="Delivery"/>
                    </Col>
                    <Col span={24}>
                        <ItemsSection booking={booking} />
                    </Col>
                </Row>
                
                <Row gutter={10}>
                    <Col xs={12}>
                        { priceCard() }
                    </Col>
                    <Col xs={12}>
                        { detailsCard() }
                    </Col>
                </Row>

                </>
            </div> 
            }
            </Form>

            <div style={{margin: 20}}>
                <FileViewer reference={booking?.crgoRef} />
            </div>
            </Col>
        </Row> 
        
        </div> : <div></div>
    )
}


const formItemStyle = {
    marginBottom: 5,
    // minHeight: 30,
    
}

const ItemsSection = ({booking}) => {

    return (
        
            <div style={{padding: 20, border: '1px solid #F1F2F5', margin: 10}}>
            
                <Row gutter={16}>
                    <Col span={4}>
                        <Form.Item name="itemCount" label="Qty" style={formItemStyle} className="small" rules={[
                            {
                                required: true,
                                message: 'Please enter the qty!',
                            }]}>
                            <div style={{margin: 10, border: '1px solid #ddd', padding: '5px 10px'}}>{booking.itemCount}</div>
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item name="itemType" label="Type"  style={formItemStyle} rules={[
                            {
                                required: true,
                                message: 'Please enter the items type!',
                            }]}>
                        <div style={{margin: 10, border: '1px solid #ddd', padding: '5px 10px'}}>{booking.itemType}</div>
                        </Form.Item>
                    </Col>
                    <Col span={4}>
                        <Form.Item name="itemKgs" label="Kgs"  style={formItemStyle} rules={[
                            {
                                required: true,
                                message: 'Please enter the weight!',
                            }]}>
                        <div style={{margin: 10, border: '1px solid #ddd', padding: '5px 10px'}}>{booking.itemKgs}</div>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="itemText" label="Description"  style={formItemStyle}>
                        <div style={{margin: 10, border: '1px solid #ddd', padding: '5px 10px'}}>{booking.itemText || <br/>}</div>
                        </Form.Item>
                    </Col>
                </Row>
            
            </div>
        
    )
}
